import { Form } from '@mairistem/composants';

import { ListeTable, ListeTableContainer } from '@mairistem/liste';
import React from 'react';
import ListeTiersRow from './ListeTiersRow';

const ListeTiers = (props) => {
  const {
    items,
    errors,
    selectedItems,
    onItemAdd,
    onItemDelete,
    onItemEdit,
    onItemSelect,
    civilites,
  } = props;

  // Gestion de la validation
  const handleValidateClick = React.useCallback(
    (item, status) => {
      if (status === 'updating') {
        return onItemEdit(item);
      }

      // status === 'creating'
      return onItemAdd(item);
    },
    [onItemAdd, onItemEdit],
  );

  // Gestion de la suppression
  const handleDeleteClick = React.useCallback((item) => onItemDelete(item), [onItemDelete]);

  // Gestion de l'ajout
  const handleAddClick = (newItem) => ({
    ...newItem,
    civilite: 'Madame',
  });

  const renderRow = React.useCallback(
    (tiers, i, rowProps, utilities) => (
      <ListeTiersRow
        tiers={tiers}
        civilites={civilites}
        rowProps={rowProps}
        utilities={utilities}
      />
    ),
    [civilites],
  );

  return (
    <Form
      autoComplete={false}
      // @ts-expect-error
      style={{ height: 300 }}
    >
      <ListeTableContainer
        items={items}
        onValidateClick={handleValidateClick}
        onDeleteClick={handleDeleteClick}
        onAddClick={handleAddClick}
        allowModifications
        allowDeletions
        allowAdditions
        additionLabel="Ajouter un tiers"
        errors={errors}
        switchToCreationIfEmpty
      >
        <ListeTable
          noResultsMessage="Aucun tiers existant"
          noResultsIcon=""
          selectedItems={selectedItems}
          selection="checkbox"
          onSelect={onItemSelect}
        >
          <ListeTable.Header>
            <ListeTable.Column name="civilite" width={2}>
              Civilité
            </ListeTable.Column>
            <ListeTable.Column name="nom" width={4}>
              Nom
            </ListeTable.Column>
            <ListeTable.Column name="prenom" width={4}>
              Prénom
            </ListeTable.Column>
            <ListeTable.Column name="adresse" width={6}>
              Adresse
            </ListeTable.Column>
          </ListeTable.Header>
          {renderRow as unknown as React.ReactNode}
        </ListeTable>
      </ListeTableContainer>
    </Form>
  );
};

export default ListeTiers;
